export interface FileForUpload extends File {
  error?: FileUploadError;
  fileUrl?: string;
  fileTypeShort?: string;
  loaded?: boolean;
  loading?: boolean;
}

export enum FileUploadError {
  TooBig = 'File is too big',
  Error = 'Error uploading file',
}

export function SortFilesByType(filesArray: FileForUpload[]) {
  // First, create a map of unique file types
  const typeGroups: { [type: string]: File[] } = {};

  // Analyze each file and group by type
  filesArray.forEach((file) => {
    // Get the general type category (image, video, etc)
    //const fileType = file.type.split('/')[0] || 'other';
    const fileType = file.type || 'other';

    // If this type doesn't exist yet, create an array for it
    if (!typeGroups[fileType]) {
      typeGroups[fileType] = [];
    }

    // Add the file to its type group
    typeGroups[fileType].push(file);
  });

  return typeGroups;
}
